const toStateSpecialAbbreviation = (state, groupType) => {
  return [
    state,
    state === 'TX' && groupType
  ].filter(Boolean).join('-')
}
export default toStateSpecialAbbreviation